import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "welcome-dialog-bg"
}
const _hoisted_3 = { class: "welcome-dialog" }
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = { class: "incoming-call" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "message" }
const _hoisted_8 = {
  key: 0,
  class: "buttons"
}
const _hoisted_9 = {
  key: 1,
  class: "buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_DialogButton = _resolveComponent("DialogButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (_ctx.showDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "message" }, "歡迎回來，請按確認來解除瀏覽器撥音限制", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_DialogButton, {
                label: "確認",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialog = false))
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.incomingCalls.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "incoming-call-bg",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("canvas", {
              id: "microphone-test",
              style: {"background-color":"black","position":"fixed","width":"30px","height":"80px"}
            }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incomingCalls, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "call-item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.message), 1),
                (item.type=='system')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_DialogButton, {
                        label: "掛斷",
                        onClick: ($event: any) => (_ctx.hangUp(item))
                      }, null, 8, ["onClick"]),
                      (!item.isConfirmed)
                        ? (_openBlock(), _createBlock(_component_DialogButton, {
                            key: 0,
                            label: "接聽",
                            onClick: ($event: any) => (_ctx.answer(item))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (item.type=='service')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_DialogButton, {
                        label: "確認",
                        onClick: ($event: any) => (_ctx.confirm(item))
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "media hidden" }, [
                  _createElementVNode("div", { id: "new-room-button" }),
                  _createElementVNode("div", { id: "videos" }, [
                    _createElementVNode("video", {
                      id: "mini-video",
                      autoplay: "",
                      playsinline: "",
                      muted: ""
                    }),
                    _createElementVNode("video", {
                      id: "remote-video",
                      autoplay: "",
                      playsinline: ""
                    }),
                    _createElementVNode("video", {
                      id: "local-video",
                      autoplay: "",
                      playsinline: "",
                      muted: ""
                    })
                  ]),
                  _createElementVNode("div", { id: "info-div" }),
                  _createElementVNode("div", {
                    id: "confirm-join-div",
                    class: "hidden"
                  }, [
                    _createElementVNode("div", null, [
                      _createTextVNode("Ready to join"),
                      _createElementVNode("span", { id: "confirm-join-room-span" }),
                      _createTextVNode("?")
                    ]),
                    _createElementVNode("button", { id: "confirm-join-button" }, "JOIN")
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", { id: "sharing-div" }, [
                      _createElementVNode("div", { id: "room-link" }, [
                        _createTextVNode("Waiting for someone to join this room: "),
                        _createElementVNode("a", {
                          id: "room-link-href",
                          href: "",
                          target: "_blank"
                        })
                      ])
                    ]),
                    _createElementVNode("div", { id: "info-div" }),
                    _createElementVNode("div", { id: "status-div" }),
                    _createElementVNode("div", { id: "turn-info-div" }),
                    _createElementVNode("div", {
                      id: "rejoin-div",
                      class: "hidden"
                    }, [
                      _createElementVNode("span", null, "You have left the call."),
                      _createTextVNode(),
                      _createElementVNode("button", { id: "rejoin-button" }, "REJOIN"),
                      _createElementVNode("button", { id: "new-room-button" }, "NEW ROOM")
                    ])
                  ]),
                  _createElementVNode("div", {
                    id: "icons",
                    class: "hidden"
                  }, [
                    _createElementVNode("svg", {
                      id: "mute-audio",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "48",
                      height: "48",
                      viewbox: "-10 -10 68 68"
                    }, [
                      _createElementVNode("title", null, "title"),
                      _createElementVNode("circle", {
                        cx: "24",
                        cy: "24",
                        r: "34"
                      }, [
                        _createElementVNode("title", null, "Mute audio")
                      ]),
                      _createElementVNode("path", {
                        class: "on",
                        transform: "scale(0.6), translate(17,18)",
                        d: "M38 22h-3.4c0 1.49-.31 2.87-.87 4.1l2.46 2.46C37.33 26.61 38 24.38 38 22zm-8.03.33c0-.11.03-.22.03-.33V10c0-3.32-2.69-6-6-6s-6 2.68-6 6v.37l11.97 11.96zM8.55 6L6 8.55l12.02 12.02v1.44c0 3.31 2.67 6 5.98 6 .45 0 .88-.06 1.3-.15l3.32 3.32c-1.43.66-3 1.03-4.62 1.03-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c1.81-.27 3.53-.9 5.08-1.81L39.45 42 42 39.46 8.55 6z",
                        fill: "white"
                      }),
                      _createElementVNode("path", {
                        class: "off",
                        transform: "scale(0.6), translate(17,18)",
                        d: "M24 28c3.31 0 5.98-2.69 5.98-6L30 10c0-3.32-2.68-6-6-6-3.31 0-6 2.68-6 6v12c0 3.31 2.69 6 6 6zm10.6-6c0 6-5.07 10.2-10.6 10.2-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c6.56-.97 12-6.61 12-13.44h-3.4z",
                        fill: "white"
                      })
                    ]),
                    _createElementVNode("svg", {
                      id: "mute-video",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "48",
                      height: "48",
                      viewbox: "-10 -10 68 68"
                    }, [
                      _createElementVNode("circle", {
                        cx: "24",
                        cy: "24",
                        r: "34"
                      }, [
                        _createElementVNode("title", null, "Mute video")
                      ]),
                      _createElementVNode("path", {
                        class: "on",
                        transform: "scale(0.6), translate(17,16)",
                        d: "M40 8H15.64l8 8H28v4.36l1.13 1.13L36 16v12.36l7.97 7.97L44 36V12c0-2.21-1.79-4-4-4zM4.55 2L2 4.55l4.01 4.01C4.81 9.24 4 10.52 4 12v24c0 2.21 1.79 4 4 4h29.45l4 4L44 41.46 4.55 2zM12 16h1.45L28 30.55V32H12V16z",
                        fill: "white"
                      }),
                      _createElementVNode("path", {
                        class: "off",
                        transform: "scale(0.6), translate(17,16)",
                        d: "M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm-4 24l-8-6.4V32H12V16h16v6.4l8-6.4v16z",
                        fill: "white"
                      })
                    ]),
                    _createElementVNode("svg", {
                      id: "fullscreen",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "48",
                      height: "48",
                      viewbox: "-10 -10 68 68"
                    }, [
                      _createElementVNode("circle", {
                        cx: "24",
                        cy: "24",
                        r: "34"
                      }, [
                        _createElementVNode("title", null, "Enter fullscreen")
                      ]),
                      _createElementVNode("path", {
                        class: "on",
                        transform: "scale(0.8), translate(7,6)",
                        d: "M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z",
                        fill: "white"
                      }),
                      _createElementVNode("path", {
                        class: "off",
                        transform: "scale(0.8), translate(7,6)",
                        d: "M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z",
                        fill: "white"
                      })
                    ]),
                    _createElementVNode("svg", {
                      id: "hangup",
                      class: "hidden",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "48",
                      height: "48",
                      viewbox: "-10 -10 68 68"
                    }, [
                      _createElementVNode("circle", {
                        cx: "24",
                        cy: "24",
                        r: "34"
                      }, [
                        _createElementVNode("title", null, "Hangup")
                      ]),
                      _createElementVNode("path", {
                        transform: "scale(0.7), translate(11,10)",
                        d: "M24 18c-3.21 0-6.3.5-9.2 1.44v6.21c0 .79-.46 1.47-1.12 1.8-1.95.98-3.74 2.23-5.33 3.7-.36.35-.85.57-1.4.57-.55 0-1.05-.22-1.41-.59L.59 26.18c-.37-.37-.59-.87-.59-1.42 0-.55.22-1.05.59-1.42C6.68 17.55 14.93 14 24 14s17.32 3.55 23.41 9.34c.37.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-4.95 4.95c-.36.36-.86.59-1.41.59-.54 0-1.04-.22-1.4-.57-1.59-1.47-3.38-2.72-5.33-3.7-.66-.33-1.12-1.01-1.12-1.8v-6.21C30.3 18.5 27.21 18 24 18z",
                        fill: "white"
                      })
                    ])
                  ]),
                  _createElementVNode("div", { id: "privacy" })
                ], -1))
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}